<medpace-page [isFullHeight]="true" [isFullWidth]="true">
    <medpace-study-expense-tracker [studyId]="studyId()" [isNewWindow]="true" />
</medpace-page>
